import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getExpiryCountdown } from "../Firebase/getExpiryCountdownAction";
import { setLicense } from "../../../functions/userIdentity/setLicense";
import signOut from "../../../functions/userIdentity/signOut";
export const FIREBASE_LICENSE_SUCCESS = "FIREBASE_LICENSE_SUCCESS";
export const FIREBASE_LICENSE_ERROR = "FIREBASE_LICENSE_ERROR";

// Thunk Action Creator
export const checkLicenseCode = createAsyncThunk(
    "api/Licence/redeemCode",
    async (json, { dispatch }) => {

        try {
            const response = await axios.post(
                /*`${import.meta.env.VITE_PUBLIC_REDIRECT_URI}api/Licence/redeemCode/${user.externalUserId}`,*/
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Licence/redeemCode`,
                {
                    Code: json.code,
                    AgreeMarketing: json.agreeMarketing
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (response.status == 200) {
                if (response.data === '') {
                    throw new Error("Problem redeeming token. Logging the user out");
                }

                dispatch(getExpiryCountdown());


                if (response.data.validCode === true) {
                    dispatch({ type: FIREBASE_LICENSE_SUCCESS, payload: response.data });
                    setLicense("true");
                }
                else {
                    dispatch({ type: FIREBASE_LICENSE_ERROR, payload: response.data });
                    setLicense("false");
                }
            }
        }
        catch(error) {
            dispatch({ type: FIREBASE_LICENSE_ERROR, payload: error });
            await signOut();
        };
    }
);
